import { render, staticRenderFns } from "./respectTab.vue?vue&type=template&id=29634166&scoped=true&"
import script from "./respectTab.vue?vue&type=script&lang=js&"
export * from "./respectTab.vue?vue&type=script&lang=js&"
import style0 from "./respectTab.vue?vue&type=style&index=0&id=29634166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29634166",
  null
  
)

export default component.exports